import type {ChatMessage} from 'chats'
import {globalChatsStore} from 'chats'

export const replaceMessageIn = (
  array: Array<ChatMessage>,
  message: ChatMessage,
): Array<ChatMessage> => {
  return array.map((m) => (m.localId === message.localId ? {...message} : m))
}

export const deleteMessageIn = (
  array: Array<ChatMessage>,
  messageId: string,
): Array<ChatMessage> => {
  return array.filter((m) => m.localId !== messageId)
}

export const deleteMessagesIn = (
  array: Array<ChatMessage>,
  messageIds: Set<string>,
): Array<ChatMessage> => array.filter((m) => !messageIds.has(m.localId))

export const isSelfMessage = (message: ChatMessage): boolean =>
  globalChatsStore.user!.hash === (message.ownerId ?? message.userId)
